/*
 * NJA members: sign up, sign in, password reset and the "My NJA" overview, backed by Supabase.
 * Load on /account/, /account/login/ and /account/register/ AFTER the Supabase CDN script:
 *   <script src="https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2.45.4/dist/umd/supabase.js"></script>
 *   <script src="/assets/nja-members.js" defer></script>
 * The key below is the PUBLISHABLE key (safe in the browser). Never put the service_role / secret key in the site.
 */
(function () {
  'use strict';

  var SUPABASE_URL = 'https://gvhsjmjcpdhuzxogdzxy.supabase.co';
  var SUPABASE_KEY = 'sb_publishable_BgdL1WgrWyPlM0I9dznzfg_tfGdKDXU';
  var MILESTONES = [10, 20, 30, 50, 100, 130, 250];

  if (!window.supabase || !window.supabase.createClient) {
    console.error('NJA members: Supabase library not loaded');
    return;
  }
  var sb = window.supabase.createClient(SUPABASE_URL, SUPABASE_KEY);
  var ORIGIN = location.origin;
  var PATH = location.pathname.replace(/index\.html$/, '').replace(/\/+$/, '') || '/';
  // Page addresses: the Netlify site's by default; the Shopify theme sets window.NJA_MEMBERS.routes
  var R = Object.assign({ account: '/account/', login: '/account/login/', register: '/account/register/', leaderboard: '/leaderboard/', book: '/pages/art-services' },
    (window.NJA_MEMBERS || {}).routes);

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') n.className = attrs[k]; else n.setAttribute(k, attrs[k]);
    });
    if (text != null) n.textContent = text;
    return n;
  }
  function msg(form, text, kind) {
    var box = $('.nja-msg', form);
    if (!box) { box = el('p', { 'class': 'nja-msg', role: 'status', 'aria-live': 'polite' }); form.appendChild(box); }
    box.textContent = text || '';
    box.className = 'nja-msg' + (kind ? ' nja-msg--' + kind : '');
  }
  function busy(form, on, label) {
    var b = $('button[type=submit]', form);
    if (!b) return;
    if (on) { b.dataset.label = b.textContent; b.textContent = label || 'One moment…'; b.disabled = true; }
    else { b.textContent = b.dataset.label || b.textContent; b.disabled = false; }
  }
  function friendly(err) {
    var m = (err && err.message) || String(err);
    if (/Invalid login credentials/i.test(m)) return 'That email and password don’t match. Try again or reset your password.';
    if (/Email not confirmed/i.test(m)) return 'Please confirm your email first. Check your inbox for the link we sent.';
    if (/already registered|already been registered/i.test(m)) return 'There’s already an account with that email. Sign in instead.';
    if (/Password should be/i.test(m)) return 'Your password needs at least 8 characters.';
    if (/rate limit/i.test(m)) return 'Too many tries in a row. Please wait a minute and try again.';
    return m;
  }
  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso + 'T12:00:00');
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }
  function fmt(n) { return Number(n || 0).toLocaleString('en-US'); }   // 1,234
  function nextMilestone(total) {
    for (var i = 0; i < MILESTONES.length; i++) if (MILESTONES[i] > total) return MILESTONES[i];
    return null;
  }
  function replaceForm(form) {          // drop the Shopify preview handler cleanly
    var clone = form.cloneNode(true);
    clone.removeAttribute('onsubmit');
    clone.setAttribute('action', '#');
    form.parentNode.replaceChild(clone, form);
    return clone;
  }

  /* ---------- REGISTER ---------- */
  function initRegister() {
    var form = $('form.acct-card');
    if (!form) return;
    form = replaceForm(form);
    var pass = $('#r-pass', form);
    if (pass) pass.setAttribute('minlength', '8');

    // Phone + "have you painted with us before?" + "name you booked under"
    var passField = pass ? pass.closest('.field') : null;
    var phone = el('div', { 'class': 'field' });
    phone.appendChild(el('label', { 'for': 'r-phone' }, 'Phone (WhatsApp)'));
    phone.appendChild(el('input', { id: 'r-phone', type: 'tel', name: 'phone', autocomplete: 'tel', placeholder: '+1 473 …' }));

    var q = el('fieldset', { 'class': 'field nja-returning' });
    q.appendChild(el('legend', null, 'Have you painted with us before?'));
    [['no', 'No, I’m new'], ['yes', 'Yes, I’ve been before']].forEach(function (o, i) {
      var lab = el('label', { 'class': 'check' });
      var r = el('input', { type: 'radio', name: 'returning', value: o[0] });
      if (i === 0) r.checked = true;
      lab.appendChild(r); lab.appendChild(document.createTextNode(' ' + o[1]));
      q.appendChild(lab);
    });
    var booked = el('div', { 'class': 'field nja-booked', hidden: '' });
    booked.appendChild(el('label', { 'for': 'r-booked' }, 'Name you usually book under'));
    booked.appendChild(el('input', { id: 'r-booked', name: 'booked_as', autocomplete: 'name' }));
    booked.appendChild(el('p', { 'class': 'small' }, 'We’ll match you to your Paint With Me history and confirm it, usually within a day.'));

    if (passField) {
      passField.parentNode.insertBefore(phone, passField);
      passField.parentNode.insertBefore(q, passField.nextSibling);
      q.parentNode.insertBefore(booked, q.nextSibling);
    }
    q.addEventListener('change', function () {
      var yes = $('input[name=returning]:checked', form).value === 'yes';
      booked.hidden = !yes;
      if (yes && !$('#r-booked', form).value) {
        $('#r-booked', form).value = [($('#r-first', form) || {}).value, ($('#r-last', form) || {}).value].join(' ').trim();
      }
    });

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      msg(form, '');
      var first = ($('#r-first', form).value || '').trim();
      var last = ($('#r-last', form).value || '').trim();
      var email = ($('#r-email', form).value || '').trim();
      var password = $('#r-pass', form).value || '';
      var returning = $('input[name=returning]:checked', form).value === 'yes';
      if (!first || !email || password.length < 8) {
        msg(form, 'Please add your first name, email and a password of at least 8 characters.', 'err'); return;
      }
      var marketing = $('input[name="customer[accepts_marketing]"]', form);
      busy(form, true, 'Creating your account…');
      var res = await sb.auth.signUp({
        email: email,
        password: password,
        options: {
          emailRedirectTo: ORIGIN + R.account,
          data: {
            first_name: first, last_name: last,
            phone: ($('#r-phone', form).value || '').trim(),
            returning: returning,
            booked_as: returning ? ($('#r-booked', form).value || '').trim() : '',
            marketing: !!(marketing && marketing.checked)
          }
        }
      });
      busy(form, false);
      if (res.error) { msg(form, friendly(res.error), 'err'); return; }
      if (res.data && res.data.session) { location.href = R.account; return; }
      msg(form, 'Almost done! We sent a confirmation link to ' + email + '. Open it to finish creating your account.', 'ok');
      form.reset();
    });
  }

  /* ---------- LOGIN + PASSWORD RESET ---------- */
  function initLogin() {
    var loginForm = $('#acct-login form');
    var recoverForm = $('#acct-recover form');
    if (loginForm) {
      loginForm = replaceForm(loginForm);
      loginForm.addEventListener('submit', async function (e) {
        e.preventDefault(); msg(loginForm, '');
        busy(loginForm, true, 'Signing in…');
        var res = await sb.auth.signInWithPassword({
          email: ($('#l-email', loginForm).value || '').trim(),
          password: $('#l-pass', loginForm).value || ''
        });
        busy(loginForm, false);
        if (res.error) { msg(loginForm, friendly(res.error), 'err'); return; }
        location.href = R.account;
      });
    }
    if (recoverForm) {
      recoverForm = replaceForm(recoverForm);
      recoverForm.addEventListener('submit', async function (e) {
        e.preventDefault(); msg(recoverForm, '');
        var email = ($('#rc-email', recoverForm).value || '').trim();
        if (!email) { msg(recoverForm, 'Enter the email on your account.', 'err'); return; }
        busy(recoverForm, true, 'Sending…');
        var res = await sb.auth.resetPasswordForEmail(email, { redirectTo: ORIGIN + R.login + '?reset=1' });
        busy(recoverForm, false);
        if (res.error) { msg(recoverForm, friendly(res.error), 'err'); return; }
        msg(recoverForm, 'If there’s an account for ' + email + ', a reset link is on its way.', 'ok');
      });
    }

    // Arriving from the reset email: show "choose a new password"
    function showNewPassword() {
      var wrap = $('#acct-login');
      if (!wrap || $('#nja-newpass')) return;
      var f = el('form', { id: 'nja-newpass', 'class': 'form acct-card', novalidate: '' });
      f.appendChild(el('h2', { 'class': 'acct-card__title' }, 'Choose a new password'));
      var fld = el('div', { 'class': 'field' });
      fld.appendChild(el('label', { 'for': 'np-pass' }, 'New password'));
      fld.appendChild(el('input', { id: 'np-pass', type: 'password', autocomplete: 'new-password', minlength: '8', required: '' }));
      f.appendChild(fld);
      f.appendChild(el('button', { 'class': 'btn acct-submit', type: 'submit' }, 'Save Password'));
      wrap.innerHTML = ''; wrap.appendChild(f);
      f.addEventListener('submit', async function (e) {
        e.preventDefault();
        var p = $('#np-pass', f).value || '';
        if (p.length < 8) { msg(f, 'At least 8 characters, please.', 'err'); return; }
        busy(f, true, 'Saving…');
        var res = await sb.auth.updateUser({ password: p });
        busy(f, false);
        if (res.error) { msg(f, friendly(res.error), 'err'); return; }
        location.href = R.account;
      });
    }
    sb.auth.onAuthStateChange(function (event) { if (event === 'PASSWORD_RECOVERY') showNewPassword(); });
    if (/[?&]reset=1/.test(location.search) && /type=recovery|access_token|code=/.test(location.hash + location.search)) showNewPassword();

    // Already signed in? Go straight to the overview (unless resetting a password).
    sb.auth.getSession().then(function (r) {
      if (r.data.session && !/[?&]reset=1/.test(location.search)) location.href = R.account;
    });
  }

  /* ---------- MY NJA OVERVIEW ---------- */
  async function initAccount() {
    var sess = (await sb.auth.getSession()).data.session;
    if (!sess) { location.replace(R.login); return; }
    var main = $('[data-nja-members]') || $('#shopify-section-main') || $('main');
    var h1 = $('.acct-hero h1', main), lede = $('.acct-hero .lede', main);
    var grid = $('.acct__grid', main);
    if (!grid) return;

    var meta = sess.user.user_metadata || {};
    var firstName = (meta.first_name || '').trim();

    var pRes = await sb.from('people').select('id, full_name, display_name, email').eq('auth_user_id', sess.user.id).maybeSingle();
    var person = pRes.data;
    if (person && !firstName) firstName = (person.full_name || '').split(' ')[0];
    if (h1) h1.textContent = 'Hi ' + (firstName || 'there');

    grid.innerHTML = '';

    // Returning painter whose history isn't linked yet
    if (!person) {
      var cRes = await sb.from('claim_requests').select('status, created_at').eq('auth_user_id', sess.user.id).order('created_at', { ascending: false }).limit(1).maybeSingle();
      var claim = cRes.data;
      if (lede) lede.textContent = 'Welcome to the NJA family.';
      var card = el('div', { 'class': 'acct-card' });
      if (claim && claim.status === 'pending') {
        card.appendChild(el('h2', { 'class': 'acct-card__title' }, 'We’re finding your history'));
        card.appendChild(el('p', null, 'We’re matching your account to your past Paint With Me sessions. This usually takes less than a day. Check back soon to see your count and milestones.'));
      } else if (claim && claim.status === 'rejected') {
        card.appendChild(el('h2', { 'class': 'acct-card__title' }, 'We couldn’t match your history'));
        card.appendChild(el('p', null, 'Message us on WhatsApp and we’ll sort it out with you.'));
      } else {
        card.appendChild(el('h2', { 'class': 'acct-card__title' }, 'Setting up your profile'));
        card.appendChild(el('p', null, 'Your profile is being created. Refresh in a moment.'));
      }
      grid.appendChild(card);
      grid.appendChild(detailsCard(sess, firstName));
      return;
    }

    var mRes = await sb.from('person_milestones').select('total_sessions, next_milestone, last_session').eq('person_id', person.id).maybeSingle();
    var total = Number((mRes.data && mRes.data.total_sessions) || 0);
    var next = nextMilestone(total);
    if (lede) lede.textContent = total ? 'Here’s your Paint With Me journey so far.' : 'Your first Paint With Me session will show up here.';

    // 1. Big number + progress line
    grid.appendChild(progressBlock(total, next));
    // 2. Badges
    grid.appendChild(badges(total));
    // 3. Recent sessions + leaderboard
    var aRes = await sb.from('attendance').select('sessions(session_date, theme, venue, type)').eq('person_id', person.id);
    var rows = (aRes.data || []).map(function (r) { return r.sessions; }).filter(Boolean)
      .sort(function (a, b) { return a.session_date < b.session_date ? 1 : -1; });
    grid.appendChild(recentCard(rows.slice(0, 3)));
    grid.appendChild(await leaderboardCard(person.display_name));
    // 4. Details + sign out
    grid.appendChild(detailsCard(sess, person.full_name));
  }

  function progressBlock(total, next) {
    var box = el('div', { 'class': 'hello hello--in nja-hero' });
    box.appendChild(el('b', { 'class': 'nja-hero__count' }, fmt(total)));
    box.appendChild(el('span', { 'class': 'nja-hero__label' }, 'Paint With Me session' + (total === 1 ? '' : 's')));

    // four marks on the line, always including the next milestone
    var ni = next ? MILESTONES.indexOf(next) : MILESTONES.length - 1;
    var start = Math.max(0, Math.min(ni - 1, MILESTONES.length - 4));
    var marks = MILESTONES.slice(start, start + 4);
    var fill;
    if (total >= marks[3]) fill = 100;
    else if (total < marks[0]) fill = (total / marks[0]) * 25;
    else {
      for (var i = 0; i < 3; i++) {
        if (total >= marks[i] && total < marks[i + 1]) fill = 25 * (i + 1) + 25 * (total - marks[i]) / (marks[i + 1] - marks[i]);
      }
    }
    var line = el('div', { 'class': 'progress-line' });
    line.style.setProperty('--fill', (fill || 0).toFixed(1) + '%');
    var label = next ? (fmt(total) + ' sessions, ' + fmt(next - total) + ' to the ' + fmt(next) + '-session milestone') : (fmt(total) + ' sessions, every milestone reached');
    var track = el('div', { 'class': 'progress-line__track', role: 'img', 'aria-label': label });
    track.appendChild(el('i', { 'class': 'progress-line__fill' }));
    marks.forEach(function (m, i) {
      var mk = el('span', { 'class': 'progress-line__mark' + (m === next ? ' is-next' : '') });
      mk.style.setProperty('--at', (25 * (i + 1)) + '%');
      mk.appendChild(el('b', null, fmt(m)));
      track.appendChild(mk);
    });
    line.appendChild(track);
    var note = el('p', { 'class': 'progress-line__note' });
    if (next) { note.appendChild(el('strong', null, fmt(next - total))); note.appendChild(document.createTextNode(' more to your ' + fmt(next) + '-session milestone')); }
    else note.textContent = 'You’ve reached every milestone. Legend.';
    line.appendChild(note);
    box.appendChild(line);
    return box;
  }

  function badges(total) {
    var wrap = el('div', { 'class': 'acct-badges nja-badges' });
    MILESTONES.forEach(function (m) {
      var b = el('div', { 'class': 'acct-badge' + (total >= m ? ' is-earned' : '') });
      b.appendChild(el('b', null, fmt(m)));
      b.appendChild(el('span', null, total >= m ? 'Earned' : fmt(m - total) + ' to go'));
      wrap.appendChild(b);
    });
    return wrap;
  }

  function recentCard(rows) {
    var card = el('div', { 'class': 'acct-card' });
    card.appendChild(el('h2', { 'class': 'acct-card__title' }, 'Your recent sessions'));
    if (!rows.length) { card.appendChild(el('p', null, 'No sessions yet. Book your first Paint With Me!')); return card; }
    var ul = el('ul', { 'class': 'acct-orders' });
    rows.forEach(function (s) {
      var li = el('li');
      var left = el('span');
      left.appendChild(el('b', null, s.theme || (s.type === 'Weekly' ? 'Paint With Me' : s.type)));
      left.appendChild(el('span', { 'class': 'small' }, fmtDate(s.session_date) + (s.venue && s.venue !== 'Main venue' ? ' · ' + s.venue : '')));
      li.appendChild(left);
      ul.appendChild(li);
    });
    card.appendChild(ul);
    return card;
  }

  async function leaderboardCard(myName) {
    var card = el('div', { 'class': 'acct-card nja-board' });
    card.appendChild(el('h2', { 'class': 'acct-card__title' }, 'Leaderboard'));
    var mine = await sb.rpc('get_my_rank');
    var me = mine.data && mine.data[0];
    var top = await sb.rpc('get_leaderboard', { max_rows: 5 });
    if (top.error || !top.data) { card.appendChild(el('p', { 'class': 'small' }, 'Leaderboard unavailable right now.')); return card; }
    function row(rank, name, total, isMe) {
      var li = el('li', isMe ? { 'class': 'is-me' } : null);
      li.appendChild(el('span', null, isMe ? name + ': #' + fmt(rank) : '#' + fmt(rank) + '  ' + name));
      li.appendChild(el('span', { 'class': 'acct-orders__total' }, fmt(total)));
      return li;
    }
    var ol = el('ol', { 'class': 'acct-orders nja-board__list' });
    var shown = false;                       // in the top 5: highlight your own row; otherwise add a "You: #N" row
    top.data.forEach(function (r) {
      var isMe = !shown && !!me && Number(r.board_rank) === Number(me.board_rank)
        && Number(r.total_sessions) === Number(me.total_sessions) && r.display_name === myName;
      if (isMe) shown = true;
      ol.appendChild(row(r.board_rank, isMe ? 'You' : r.display_name, r.total_sessions, isMe));
    });
    if (me && !shown) ol.appendChild(row(me.board_rank, 'You', me.total_sessions, true));
    card.appendChild(ol);
    var all = el('p', { 'class': 'small' });
    all.appendChild(el('a', { 'class': 'textlink', href: R.leaderboard }, 'See the full leaderboard'));
    card.appendChild(all);
    return card;
  }

  function detailsCard(sess, name) {               // one quiet line: name · email · Sign Out
    var line = el('p', { 'class': 'nja-me-line' });
    if (name) line.appendChild(el('b', null, name));
    if (sess.user.email) line.appendChild(el('span', null, sess.user.email));
    var out = el('button', { type: 'button', 'class': 'textlink nja-signout' }, 'Sign Out');
    out.addEventListener('click', async function () { await sb.auth.signOut(); location.href = '/'; });
    line.appendChild(out);
    return line;
  }

  /* ---------- PUBLIC LEADERBOARD (/leaderboard/): podium for the top 3, ranked rows below ---------- */
  var CALM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var AVATAR_TINTS = ['#ff99ff', '#ffc94d', '#ffc9ff', '#c9a6f0', '#9ee6c9', '#ffb38a'];

  function initials(name) {
    return (name || '?').replace(/\./g, '').split(/\s+/).filter(Boolean).slice(0, 2)
      .map(function (w) { return w.charAt(0).toUpperCase(); }).join('');
  }
  function avatar(name, i) {
    var a = el('span', { 'class': 'lb-avatar', 'aria-hidden': 'true' }, initials(name));
    a.style.setProperty('--av', AVATAR_TINTS[i % AVATAR_TINTS.length]);
    return a;
  }
  function countUp(node, to) {                      // podium numbers tick up as the blocks rise
    if (CALM || !to) { node.textContent = String(to); return; }
    var t0 = null, dur = 900;
    function step(t) {
      t0 = t0 || t;
      var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      node.textContent = String(Math.round(to * e));
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function milestoneProgress(total) {
    var next = nextMilestone(total), prev = 0;
    MILESTONES.forEach(function (m) { if (m <= total) prev = m; });
    return { next: next, pct: next ? Math.round(100 * (total - prev) / (next - prev)) : 100 };
  }
  var CROWN = '<svg class="lb-crown" viewBox="0 0 32 22" aria-hidden="true"><path d="M2 6l7 6 7-10 7 10 7-6-3 15H5z" fill="currentColor"/></svg>';

  function podiumStep(row, place, order) {
    var li = el('li', { 'class': 'lb-step lb-step--' + place });
    li.style.setProperty('--i', String(order));
    var who = el('div', { 'class': 'lb-who' });
    if (place === 1) who.insertAdjacentHTML('beforeend', CROWN);
    if (row) {
      who.appendChild(avatar(row.display_name, place - 1));
      who.appendChild(el('b', { 'class': 'lb-name' }, row.display_name));
      var c = el('span', { 'class': 'lb-count' });
      var n = el('b', null, '0');
      c.appendChild(n); c.appendChild(document.createTextNode(' sessions'));
      who.appendChild(c);
      countUp(n, Number(row.total_sessions));
    } else {
      var empty = el('span', { 'class': 'lb-avatar lb-avatar--open', 'aria-hidden': 'true' }, '?');
      who.appendChild(empty);
      who.appendChild(el('b', { 'class': 'lb-name' }, 'Your spot?'));
    }
    var block = el('div', { 'class': 'lb-block', 'aria-hidden': 'true' });
    block.appendChild(el('span', null, String(row ? row.board_rank : place)));
    li.appendChild(who); li.appendChild(block);
    li.setAttribute('aria-label', row ? ('#' + row.board_rank + ' ' + row.display_name + ', ' + row.total_sessions + ' sessions') : ('Place ' + place + ' is open'));
    return li;
  }

  function meCard(rows, me, signedIn) {
    var box = el('div', { 'class': 'lb-me' });
    var text = el('p', { 'class': 'lb-me__text' });
    var actions = el('p', { 'class': 'lb-me__actions' });
    if (me) {
      var above = rows.filter(function (r) { return Number(r.total_sessions) > Number(me.total_sessions); }).pop();
      text.appendChild(el('b', null, 'You’re #' + me.board_rank + ' of ' + me.on_board));
      var gap;
      if (Number(me.board_rank) === 1) gap = 'Top of the board. Keep the crown!';
      else if (above) gap = (Number(above.total_sessions) - Number(me.total_sessions) + 1) + ' more session' + (Number(above.total_sessions) - Number(me.total_sessions) === 0 ? '' : 's') + ' to pass ' + above.display_name;
      else if (rows.length) gap = (Number(rows[rows.length - 1].total_sessions) - Number(me.total_sessions) + 1) + ' more sessions to break into the top ' + rows.length;
      if (gap) text.appendChild(el('span', null, gap));
    } else if (signedIn) {
      text.appendChild(el('b', null, 'Your first session puts you on the board'));
      text.appendChild(el('span', null, 'Every Paint With Me you attend moves you up.'));
    } else {
      text.appendChild(el('b', null, 'Where do you rank?'));
      text.appendChild(el('span', null, 'Create your free account to see your count and your place.'));
      actions.appendChild(el('a', { 'class': 'btn btn--ghost', href: R.register }, 'Join'));
    }
    actions.appendChild(el('a', { 'class': 'btn btn--pink', href: R.book }, 'Book a Session'));
    box.appendChild(text); box.appendChild(actions);
    return box;
  }

  function rankRow(row, i, me) {
    var li = el('li', { 'class': 'lb-row' });
    li.style.setProperty('--i', String(i));
    var isMe = me && Number(me.board_rank) === Number(row.board_rank) && Number(me.total_sessions) === Number(row.total_sessions);
    if (isMe) li.className += ' is-me';
    li.appendChild(el('span', { 'class': 'lb-row__rank' }, String(row.board_rank)));
    li.appendChild(avatar(row.display_name, i + 3));
    var mid = el('span', { 'class': 'lb-row__who' });
    var nm = el('b', null, row.display_name);
    if (isMe) nm.appendChild(el('span', { 'class': 'lb-you' }, 'You'));
    mid.appendChild(nm);
    var mp = milestoneProgress(Number(row.total_sessions));
    mid.appendChild(el('span', { 'class': 'lb-row__next' }, mp.next ? (mp.next - row.total_sessions) + ' to the ' + mp.next + ' badge' : 'Every badge earned'));
    var bar = el('span', { 'class': 'lb-bar', 'aria-hidden': 'true' });
    var fill = el('i'); fill.style.setProperty('--p', mp.pct + '%'); bar.appendChild(fill);
    mid.appendChild(bar);
    li.appendChild(mid);
    var cnt = el('span', { 'class': 'lb-row__count' });
    cnt.appendChild(el('b', null, String(row.total_sessions)));
    cnt.appendChild(el('small', null, 'sessions'));
    li.appendChild(cnt);
    return li;
  }

  function renderBoard(root, rows, me, signedIn) {
    root.innerHTML = '';
    var stage = el('div', { 'class': 'lb-stage' });
    stage.appendChild(el('p', { 'class': 'lb-kicker' }, 'Paint With Me · All time'));
    var podium = el('ol', { 'class': 'lb-podium', 'aria-label': 'Top three painters' });
    [[rows[1], 2], [rows[0], 1], [rows[2], 3]].forEach(function (p, order) { podium.appendChild(podiumStep(p[0], p[1], [1, 0, 2][order])); });
    stage.appendChild(podium);
    root.appendChild(stage);
    root.appendChild(meCard(rows, me, signedIn));
    if (rows.length > 3) {
      var list = el('ol', { 'class': 'lb-list', start: '4', 'aria-label': 'Ranks 4 to ' + rows.length });
      rows.slice(3).forEach(function (r, i) { list.appendChild(rankRow(r, i, me)); });
      root.appendChild(list);
    } else if (!rows.length) {
      root.appendChild(el('p', { 'class': 'lb-note' }, 'The board is getting ready. Book a session and claim the first spot!'));
    }
  }

  async function initLeaderboard() {
    var root = $('#nja-leaderboard');
    if (!root) return;
    var top = await sb.rpc('get_leaderboard', { max_rows: 25 });
    var sess = (await sb.auth.getSession()).data.session, me = null;
    if (sess) { var mine = await sb.rpc('get_my_rank'); me = mine.data && mine.data[0]; }
    root.removeAttribute('aria-busy');
    if (top.error || !top.data) { root.innerHTML = ''; root.appendChild(el('p', { 'class': 'lb-note' }, 'Leaderboard unavailable right now.')); return; }
    renderBoard(root, top.data, me, !!sess);
  }

  /* ---------- "My NJA" links site-wide: send signed-in members to their overview ---------- */
  function fixAccountLinks() {
    sb.auth.getSession().then(function (r) {
      if (!r.data.session) return;
      document.querySelectorAll('a[href="/account/register"], a[href="/account/login"]').forEach(function (a) {
        if (!a.closest('.acct')) a.setAttribute('href', R.account);
      });
    });
  }

  /* ---------- route ---------- */
  function start() {
    // the Shopify section names its view; the Netlify pages are found by address
    var holder = $('[data-nja-members]');
    var view = holder ? holder.getAttribute('data-nja-members')
      : { '/account/register': 'register', '/account/login': 'login', '/account': 'account', '/leaderboard': 'leaderboard' }[PATH];
    if (view === 'register') initRegister();
    else if (view === 'login') initLogin();
    else if (view === 'account') initAccount();
    else if (view === 'leaderboard') initLeaderboard();
    fixAccountLinks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
